/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./package-setting.vue?vue&type=template&id=257a00cc&scoped=true&"
import script from "./package-setting.vue?vue&type=script&lang=js&"
export * from "./package-setting.vue?vue&type=script&lang=js&"
import style0 from "./package-setting.vue?vue&type=style&index=0&id=257a00cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257a00cc",
  null
  
)

export default component.exports